var exports = {
  "k": "xe564cbfb--f102c2--container",
};

module.exports = exports;
